<div class="p-20" fxLayout="column" fxLayoutAlign="start stretch">
  <div fxLayout="row" fxLayoutAlign="center center" class="mb-20" *ngIf="surveyProduct">
    <h3>{{'VOICE.ENABLE' | translate}}</h3>
    <mat-slide-toggle class="ml-20" [(ngModel)]="surveyProduct.enableAudio" (change)="setStatusAudios()" [disabled]="pasoCompleto"></mat-slide-toggle>
  </div>

  <h2>{{'VOICE.TITULO' | translate}}</h2>
  <em>{{'VOICE.SUBTITULO' | translate}}</em>
  <mat-stepper [linear]="false" #stepper (selectionChange)="testStep($event)">
    <mat-step *ngFor="let idioma of idiomas">
      <ng-template matStepLabel>{{'NOMBREIDIOMAS.' + idioma.nombreIdioma | translate}}</ng-template>
      <mat-card class="example-card">
        <mat-card-header>
          <mat-card-subtitle>{{'VOICE.CONFIG_IDIOMA.TITULO' | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="valoresForm[idioma.nombreIdioma] && catVocesProd[idioma.nombreIdioma]">

            <mat-form-field appearance="outline" fxFlex="49">
              <mat-label>{{'VOICE.CONFIG_IDIOMA.GENERO.TITULO' | translate}}</mat-label>
              <mat-select [(ngModel)]="valoresForm[idioma.nombreIdioma].genero" [disabled]="pasoCompleto">
                <mat-option *ngFor="let opcion of catVocesProd[idioma.nombreIdioma].genders" [value]="opcion.gender" (click)="eligeGenero(opcion)">
                  {{'VOICE.CONFIG_IDIOMA.GENERO.' + opcion.gender | translate}}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix class="secondary-text">people</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="49">
              <mat-label>{{'VOICE.CONFIG_IDIOMA.TIPO_VOZ.TITULO' | translate}}</mat-label>
              <mat-select [(ngModel)]="valoresForm[idioma.nombreIdioma].tipoVoz" fxFlex="49" [disabled]="pasoCompleto">
                <mat-option *ngFor="let opcion of listaVocesSel; let idxVox = index;" [value]="opcion.nameVoice" (click)="eligeVoz(opcion, idioma.nombreIdioma)">
                  {{'VOICE.CONFIG_IDIOMA.TIPO_VOZ.' + (idxVox + 1) | translate}}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix class="secondary-text">record_voice_over</mat-icon>
            </mat-form-field>

          </div>
          <div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="catVocesProd[idioma.nombreIdioma]">
            <p><em>{{'VOICE.CONFIG_IDIOMA.PRUEBA_VOZ.TITULO' | translate}}</em></p>
            <mat-form-field appearance="outline">
              <mat-label>{{'VOICE.CONFIG_IDIOMA.PRUEBA_VOZ.INSTRUCCION' | translate}}</mat-label>
              <textarea matInput [(ngModel)]="catVocesProd[idioma.nombreIdioma].textExample" placeholder="{{'VOICE.CONFIG_IDIOMA.PRUEBA_VOZ.PLACEHOLDER' | translate}}"></textarea>
              <mat-icon matSuffix>edit</mat-icon>
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="end">
              <button mat-raised-button (click)="tts(catVocesProd[idioma.nombreIdioma].textExample, idioma.nombreIdioma)" color="accent" [disabled]="guardandoTemplate ||  valoresForm[idioma.nombreIdioma].tipoVoz == ''">
                <mat-icon class="mr-20">play_arrow</mat-icon>
                {{'VOICE.CONFIG_IDIOMA.PRUEBA_VOZ.PROBAR' | translate}}
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-step>
  </mat-stepper>


</div>
<div class="guardandoTemplate" *ngIf="guardandoTemplate" fxLayout="row" fxLayoutAlign="start center">
  <em class="mr-20">{{'EDITOR.GUARDANDO'|translate}}</em>
  <mat-spinner diameter="25"></mat-spinner>
</div>

<div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
  <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab matTooltip="{{'CERTIFICAR.IDIOMAS.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20">
    <mat-icon>done</mat-icon>
  </button>
  <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
    {{'CERTIFICAR.IDIOMAS.STATUS.DONE' | translate}}
    <mat-icon class="ml-20">done</mat-icon>
  </button>
  <!-- desbloquearPaso -->
  <!-- <button *ngIf="pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearIdiomas()" mat-fab  matTooltip="{{'CERTIFICAR.IDIOMAS.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20">
    <mat-icon>lock_open</mat-icon>
  </button>

  <button *ngIf="!pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearIdiomas()" mat-raised-button class="reopen mr-20">
    {{'CERTIFICAR.IDIOMAS.STATUS.UNLOCK' | translate}}
  </button> -->

</div>
